import type { PropsWithChildren, ReactNode } from "react";

import { Badge } from "@similarweb/ui-components";

import { CRM_ENRICHMENT_CONTENT_ID } from "app/pages/sales-intelligence/modules/crm-enrichment/constants";
import { useTranslation } from "pro-features/components/WithTranslation";
import InfoIconTooltip from "app/pages/sales-intelligence/common-components/tooltip/InfoIconTooltip";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

import {
    StyledEnrichmentHeaderWrapper,
    StyledIntegrationTabContainer,
    StyledSectionHeaderWrapper,
} from "../../styles/styles";
import SectionTitleContainer from "../SectionTitleContainer/SectionTitleContainer";

type Props = PropsWithChildren<{
    integration: Integration;
    actions?: ReactNode;
}>;

export const EnrichmentSection = ({ children, actions, integration }: Props) => {
    const translate = useTranslation();

    const contentId = CRM_ENRICHMENT_CONTENT_ID[integration];
    const dataAutomationPrefix = `crm-enrichment.${contentId}`;
    const i18nPrefix = `si.crm-enrichment.${contentId}`;

    return (
        <StyledIntegrationTabContainer data-automation={`${dataAutomationPrefix}.section`}>
            <StyledSectionHeaderWrapper>
                <StyledEnrichmentHeaderWrapper>
                    <SectionTitleContainer
                        dataAutomation={`${dataAutomationPrefix}.title`}
                        title={translate(`${i18nPrefix}.title`)}
                        description={translate(`${i18nPrefix}.description`)}
                    >
                        <InfoIconTooltip tooltipKey={`${i18nPrefix}.title.tooltip`} />

                        <Badge type="new" />
                    </SectionTitleContainer>

                    {actions}
                </StyledEnrichmentHeaderWrapper>
            </StyledSectionHeaderWrapper>

            {children}
        </StyledIntegrationTabContainer>
    );
};
